import axios from "axios";
import store from "~/store/index";
import router from "../router";
import i18n from "./i18n";
// import { createToastInterface } from 'vue-toastification';
// import Toaster from "@incuca/vue3-toaster";
// import { createToaster } from "@incuca/vue3-toaster";
//
// const toaster = createToaster();

// import 'vue-toastification/dist/index.css';


axios.interceptors.request.use(
  (config) => {
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    // const cookies = useCookies(['locale'])
    // config.headers["X-XSRF-TOKEN"] = "";
    config.withCredentials = true;

    // config.headers["X-XSRF-TOKEN"] = decodeURIComponent(Cookies.get('laravel_session'));
    // config.headers["X-XSRF-TOKEN"] = decodeURIComponent(Cookies.get('XSRF-TOKEN'));

    const locale = store.getters["lang/locale"];
    if (locale) {
      config.headers["Accept-Language"] = locale;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    let currentRoute = router.currentRoute.value;

    if (error.response?.status === 401 || error.response?.status === 419) {

      const excludedRoutes = ["/"];


      if (currentRoute.name === "auth.login") {
        return Promise.reject(error);
      }

      if (
        !excludedRoutes.includes(currentRoute.name) &&
        !excludedRoutes.includes(currentRoute.fullPath)
      ) {
        await router.replace({
          name: "auth.login",
          query: { redirect: currentRoute.fullPath }
        });
        return;
      } else if (excludedRoutes.includes(currentRoute.fullPath)) {
        await router.replace({
          name: "auth.login",
          query: { loggedOut: "true" }
        });
        return;
      }
    }
    if (error.response?.status === 419) {
      // TODO тут бы показывать флеш сообщение что куки прошли и пора перейти на страницу логина. Но при этом в урле сотавить путь на котором был пользователь в процессе чего он там был
    }


    if (error.response?.status === 403 && currentRoute.name !== "auth.login") {
      window.$toast.error(i18n.global.t("response.403"));
    }

    return Promise.reject(error);
  }
);
